import { deleteOutputRatio } from "@erp/shared/api/generated/wrappers/backdata";
import { patchOutputRatio, } from "@erp/shared/api/generated/wrappers/backdata";
import { postOutputRatio, } from "@erp/shared/api/generated/wrappers/backdata";
import { useInvalidateQueries } from "@erp/shared/composables/useInvalidateQueries";
import { queries } from "@erp/shared/queries";
import { showAlert } from "@erp/shared/utils/dialog";
import { getErrorMessage } from "@erp/shared/utils/error";
import { useMutation, useQuery } from "@tanstack/vue-query";
export const useOutputRatioAction = () => {
    const { invalidateQueries } = useInvalidateQueries();
    const readQuery = useQuery(queries.laborCost.outputRatio());
    const createMutation = useMutation({
        mutationFn: async (body) => await postOutputRatio(body),
        onSuccess: () => {
            showAlert("산출비율 정보 등록 완료", "완료");
            invalidateQueries([queries.laborCost.outputRatio().queryKey]);
        },
        onError: (err) => {
            showAlert(getErrorMessage(err), "산출비율 정보 등록 실패");
        },
    });
    const updateMutation = useMutation({
        mutationFn: async ({ id, body, }) => await patchOutputRatio(id, body),
        onSuccess: () => {
            showAlert("산출비율 정보 수정 완료", "완료");
            invalidateQueries([queries.laborCost.outputRatio().queryKey]);
        },
        onError: (err) => {
            showAlert(getErrorMessage(err), "산출비율 정보 수정 실패");
        },
    });
    const deleteMutation = useMutation({
        mutationFn: async (id) => await deleteOutputRatio(id),
        onSuccess: () => {
            showAlert("산출비율 정보 삭제 완료", "완료");
            invalidateQueries([queries.laborCost.outputRatio().queryKey]);
        },
        onError: (err) => {
            showAlert(getErrorMessage(err), "산출비율 정보 삭제 실패");
        },
    });
    return {
        readQuery,
        createMutation,
        updateMutation,
        deleteMutation,
    };
};
